import { InjectionToken } from "@angular/core";
import { ExpenseReportsPort } from "./expense-reports.port";

export const EXPENSE_REPORTS_PORT = new InjectionToken<ExpenseReportsPort>("EXPENSE_REPORTS_PORT");
